import { useCallback } from 'react';
import { useVFSAuthFetch } from '@/hooks/useAuthenticatedFetch';
import { buildMobileAppStore, shopStore } from '@/stores';

export const useGetAppleEmail = () => {
    const fetchVFSAuthFetch = useVFSAuthFetch();
    const getAppleEmail = useCallback(async () => {
        try {
            buildMobileAppStore.isAppleEmailLoading = true;
            const response = await fetch(`/api/shopify/shop/mobile/apple-email?shopifySubdomain=${shopStore.shopifyDomain}`);
            const resp = await response.json();
            if (resp?.data) {
                const { emailAddress } = resp.data;
                buildMobileAppStore.rotatingAppleEmail = emailAddress;
            }
        } catch (e) {
            shopify.toast.show(
                'Failed to get plan information. Please contact support.',
                {
                    isError: true,
                    duration: 5000,
                },
            );
        } finally {
            buildMobileAppStore.isAppleEmailLoading = false;
        }
    }, [fetchVFSAuthFetch]);
    return {
        getAppleEmail,
    };
};
